import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Checkbox } from '@fiverr-private/fit';
import { commaSeparateNumber } from '@fiverr-private/futile';

const CheckboxGroup = ({ value, id, options, maxCheckBoxes, visibleCheckBoxes, onChange }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const onChangeHandler = (selectedValue, isChecked) => {
        const newSelected = isChecked ? [...value, selectedValue] : value.filter((v) => v !== selectedValue);
        onChange(id, newSelected.sort());
    };

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const shouldCollapse = options.length > maxCheckBoxes;
    const renderedOptions = shouldCollapse && isCollapsed ? options.slice(0, visibleCheckBoxes) : options;

    return (
        <ul className={'checkbox-group'}>
            {renderedOptions.map(({ id, name, alias, count }) => {
                const isChecked = value && value.includes(id);
                return (
                    <li key={id} className="box-shadow-z1">
                        <Checkbox key={id}
                            value={id}
                            name={name}
                            onChange={() => onChangeHandler(id, !isChecked)}
                            checked={isChecked}>
                            {alias}
                        </Checkbox>
                        {count && <span>({commaSeparateNumber(count)})</span>}
                    </li>
                );
            })}
            {shouldCollapse &&
            <button className="toggle-list" onClick={toggleCollapse}>
                <I18n k={`search_perseus.filter.${isCollapsed ? 'show_more' : 'show_less'}`}/>
            </button>
            }
        </ul>
    );
};

CheckboxGroup.propTypes = {
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    options: PropTypes.array,
    id: PropTypes.string,
    maxCheckBoxes: PropTypes.number,
    visibleCheckBoxes: PropTypes.number,
    onChange: PropTypes.func
};

CheckboxGroup.defaultProps = {
    value: [],
    options: [],
    maxCheckBoxes: 4,
    visibleCheckBoxes: 3,
    onChange: () => true
};

export default CheckboxGroup;
